import * as React from "react";

export const DoneIcon = (props: any) => (
  <svg
    width="12"
    height="12"
    viewBox="2 0 5 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.5 5.586L8.096 0.989502L8.8035 1.6965L3.5 7L0.318001 3.818L1.025 3.111L3.5 5.586Z"
      fill="#4CAF50"
    />
  </svg>
);
